module.exports = "https://static.wmbcdn.com/uniweb/images/b8bfbbcae6ccf04c9746f6b6164dfb60.svg";